import type { GenericEntityObject, QueryParams } from "../../../../components/Form/types/types";
import { getMapperFor } from "../../../../core/mappers/Mapper";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { GenericObject } from "../../../../core/types";
import type { Dto } from "../../../../core/types/be/Dto";
import type { Entity } from "../../../../core/types/fe/Entity";

export const formApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadGenericForm: builder.query<Entity, QueryParams>({
            providesTags: ["mainCache"],
            query: (queryParams) => {
                const dataGroup = queryParams.dataGroupId && `data-groups/${queryParams.dataGroupId}`;
                const resourceQuery = queryParams.entityId ? `${queryParams.resource}/${queryParams.entityId}` : `${queryParams.resource}/`;
                return {
                    url: dataGroup ? `${dataGroup}/${resourceQuery}` : resourceQuery,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _, query) => {
                const map = getMapperFor(`${query.resource}-dto`);
                return map(response);
            },
        }),
        saveGenericForm: builder.mutation<GenericObject, GenericEntityObject>({
            query: (genericEntityObject) => {
                const dataGroup = genericEntityObject.query.dataGroupId ? `data-groups/${genericEntityObject.query.dataGroupId}` : "";
                // default values are for create new resource with POST
                let url = `${dataGroup}/${genericEntityObject.query.resource}`;
                let method = "POST";
                // if id present that means resource exist and we updating it with PUT
                if (genericEntityObject.query.entityId) {
                    method = "PUT";
                    url = `${url}/${genericEntityObject.query.entityId}`;
                }

                // Apply a mapping process. If the resource's mapper doesn't exist then it does nothing.
                const resourceName = genericEntityObject.query.resourceName || genericEntityObject.query.resource;
                const mapper = getMapperFor(resourceName);
                const body = mapper(genericEntityObject.genericFormData);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: ["mainCache"],
        }),
    }),
});

export const { useLazyLoadGenericFormQuery, useSaveGenericFormMutation } = formApi;
